module.exports = __webpack_public_path__ + "static/media/image_3x2.e3e19891.png";